// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"404":"c02b99ad","410":"80a804ea"}[chunkId] + ".chunk.css";
};